import { FC, memo } from 'react';
import { ScrapersDto } from '@api/apiCompat';

import { Paper, PaperProps } from '@mui/material';

const AutocompletePaper: FC = (props: PaperProps & { options?: ScrapersDto[] }) => <Paper elevation={8} {...props} />;

export default memo(AutocompletePaper);
